
<template>
      <v-dialog
        v-model="modal"
        persistent
        width="290"
        attach="body"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="displayText"
            readonly
            v-bind="attrs"
            v-on="on"
            :label="label"
            outlined
            dense
            append-icon="mdi-calendar"
            class="no-details"
          />
        </template>
  
        <v-card>
          <v-date-picker
            v-model="tempValue"
            type="month"
            scrollable
            :min="min"
            :max="max"
            color="primary"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
            <v-btn text color="primary" @click="confirm">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </template>
  
  <script>
  export default {
    name: "MonthPicker",
    props: {
      value: {
        type: String,
        default: () => new Date().toISOString().slice(0, 7), // Format 'YYYY-MM'
      },
      label: {
        type: String,
        default: "Pilih Bulan",
      },
      min: {
        type: String,
        default: "2022-08",
      },
      // max: {
      //   type: String,
      //   default: () => new Date().toISOString().slice(0, 7),
      // },
    },
    data() {
      return {
        modal: false,
        tempValue: this.value,
      };
    },
    watch: {
      value(val) {
        this.tempValue = val;
      }
    },
    computed: {
      displayText() {
        return this.value;
      }
    },
    methods: {
      confirm() {
        this.modal = false;
        this.$emit("input", this.tempValue); // Vue 2 compatible v-model
      }
    }
  };
  </script>
  